import React, { useContext } from "react";
import styled from "styled-components";
import { ColorContext } from "./Bootstrap";

const SplitButtonElement = styled.div`
  display: inline-flex;
  ${(props) => `border: 1px solid ${props.mainColor};`}
  border-radius: 8px;
  ${(props) => (props.disabled ? "opacity: 0.6" : "opacity: 1")}
  overflow: hidden;
  box-shadow: 0 3px 10px rgba(6, 40, 59, 0.06);
`;

const SplitButtonClickSpot = styled.div`
  padding: 10px 14px;
  background-color: #fff;
  color: var(--app-ink);
  cursor: pointer;
  font-weight: 700;
  text-align: center;

  ${(props) => `border-right: 1px solid ${props.mainColor};`}

  &:last-child {
    border-right: none;
  }

  &.selected {
    color: #fff;
    ${(props) => `background-color: ${props.mainColor};`}
  }

  &:hover {
    background-color: var(--app-surface-soft);
  }
`;

function SplitButton(props) {
  const { options, onChange, value, disabled } = props;
  const mainColor = useContext(ColorContext);

  return (
    <SplitButtonElement mainColor={mainColor} disabled={disabled}>
      {options.map((option) => (
        <SplitButtonClickSpot
          mainColor={mainColor}
          onClick={() => {
            if (!disabled) {
              onChange(option.value);
            }
          }}
          className={value === option.value ? "selected" : ""}
        >
          {option.display}
        </SplitButtonClickSpot>
      ))}
    </SplitButtonElement>
  );
}

SplitButton.defaultProps = {
  componentType: "SplitButton",
};

export default SplitButton;
